"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artist = void 0;
const members_1 = require("./artist/members");
exports.artist = { members: members_1.members };
//# sourceMappingURL=index.js.map